var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54199 17.125V14.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 17.125V12.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 5.25V2.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54199 7.625V2.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54199 14.75C4.80425 14.75 4.43538 14.75 4.14441 14.6295C3.75645 14.4688 3.44822 14.1605 3.28752 13.7726C3.16699 13.4816 3.16699 13.1128 3.16699 12.375C3.16699 11.6372 3.16699 11.2684 3.28752 10.9774C3.44822 10.5895 3.75645 10.2812 4.14441 10.1205C4.43538 10 4.80425 10 5.54199 10C6.27973 10 6.6486 10 6.93958 10.1205C7.32753 10.2812 7.63577 10.5895 7.79647 10.9774C7.91699 11.2684 7.91699 11.6372 7.91699 12.375C7.91699 13.1128 7.91699 13.4816 7.79647 13.7726C7.63577 14.1605 7.32753 14.4688 6.93958 14.6295C6.6486 14.75 6.27973 14.75 5.54199 14.75Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 10C12.7203 10 12.3514 10 12.0604 9.87951C11.6725 9.7188 11.3642 9.41053 11.2035 9.02261C11.083 8.73159 11.083 8.36274 11.083 7.625C11.083 6.88726 11.083 6.51839 11.2035 6.22742C11.3642 5.83946 11.6725 5.53122 12.0604 5.37052C12.3514 5.25 12.7203 5.25 13.458 5.25C14.1958 5.25 14.5646 5.25 14.8556 5.37052C15.2435 5.53122 15.5518 5.83946 15.7125 6.22742C15.833 6.51839 15.833 6.88726 15.833 7.625C15.833 8.36274 15.833 8.73159 15.7125 9.02261C15.5518 9.41053 15.2435 9.7188 14.8556 9.87951C14.5646 10 14.1958 10 13.458 10Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.f9d74dc6b9ac1ae75e4579d3bd2d3d6c.svg";
export { ForwardRef as ReactComponent };